import required from "@libs/required";

export default (textFieldType = required`textFieldType`) => function (props, propName, componentName) {
    if (props[propName] === undefined) return;
    return new Error(`
            Invalid prop ${propName} supplied to ${componentName}. 
            Unsupported prop for TextField type "${textFieldType}"
        `);
}